export const changeUsername = (username?: string) => {
    let newName;
    while (!newName) {
        newName = prompt("אז, איך קוראים לנו?", username) ?? username;
    }
    localStorage.setItem('username', newName);
    return newName;
};